import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Dialog, Illustration } from '@node-space/ui-components'
import { sumNumbers } from '@node-space/utils'
import { useProfileContext } from 'hooks/context/useProfileContext'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'
import { roundNumberWithCommas } from 'utils/utils'
import { WithdrawActionProps } from './Withdraw'

const WithdrawComplete = ({
  dismissAction,
  form,
  wallets,
  refresh,
  withdrawalFee,
}: WithdrawActionProps) => {
  const { t } = useTranslation()

  const { profile } = useProfileContext()
  const formValues = form.watch()

  // refresh wallets
  useEffect(() => {
    track.Amp.track(AmplitudeEvent.WITHDRAW_SUCCESS, {
      category: AmplitudeEventCategory.MERCHANT_PORTAL,
      action: AmplitudeEventAction.VIEW,
      currency: selectedWallet?.currency?.code?.toLowerCase(),
      walletId: selectedWallet?.id,
      amount: formValues.amount,
      fee: withdrawalFee?.fee ?? 0,
    })
    refresh()
  }, [])
  const selectedWallet =
    formValues.walletId && wallets.find(x => x.id.toString() === formValues.walletId)

  return (
    <Dialog
      open
      onClose={dismissAction}
      title={t('transactionSubmitted')}
      Illustration={<Illustration name="HandsClapping" color="success" />}
      ActionButtons={[
        <Button key="done" onClick={dismissAction}>
          {t('done')}
        </Button>,
      ]}
    >
      <Box flexCol gap={12}>
        <p className="text-foreground-prominent text-body-regular text-center">
          {`${roundNumberWithCommas(
            sumNumbers(parseFloat(formValues?.amount?.toString()), withdrawalFee?.fee ?? 0)
          )} ${selectedWallet?.currency?.code} ${t('withdrawn')}`}
        </p>
        <p className="text-foreground-prominent text-body-regular text-center">
          {`${t('withdrawProcess')} `}
          {!profile?.twoFactorEnabled && t('withdraw2FAAdditional')}
        </p>
        <p className="text-foreground-prominent text-body-regular text-center">
          {t('withdrawDelay')}
        </p>
      </Box>
    </Dialog>
  )
}

export default WithdrawComplete
